<template>
  <div class="tab">
    <el-footer v-if="showManageFooter" class="tab__footer page__active_bar">
      <el-button
        v-if="$can('update', 'clients')"
        class="page__active_button"
        id="submit"
        type="primary"
        :loading="isSaving"
        @click="submit"
      >
        Сохранить
      </el-button>
      <el-button
        v-if="$can('delete', 'clients')"
        class="page__active_button"
        id="delete"
        type="danger"
        :disabled="isSaving"
        @click="removeClient"
      >
        Удалить
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-form class="page__form" :model="form" ref="form" :rules="rules" label-position="right" label-width="150px">
        <el-row :gutter="24">
          <el-col v-if="canUseCrossSharing" :span="12">
            <el-form-item
              label="Клиенту можно пошарить камеру любого оператора"
              prop="cross_sharing_enabled"
              label-width="auto"
            >
              <el-switch
                v-model="form.cross_sharing_enabled"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="$can('read', 'clients_fbs')"
            :span="12"
          >
            <el-form-item
              label="Доступна аналитика Сканирование ШК"
              prop="is_fbs"
              label-width="auto"
            >
              <el-switch
                v-model="isFbs"
                active-color="#09ce65"
                :disabled="!$can('update', 'clients_fbs')"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Имя" prop="client_name">
          <el-input id="client_name" size="small" v-model="form.client_name" :readonly="!$can('update', 'clients')" />
        </el-form-item>
        <el-form-item label="Логин" prop="login">
          <el-input id="login" size="small" v-model="form.login" :readonly="!$can('update', 'clients')" />
        </el-form-item>
        <el-form-item label="Номер телефона" prop="phone">
          <el-input id="phone" size="small" v-model="form.phone" :readonly="!$can('update', 'clients')"/>
        </el-form-item>
        <el-form-item label="Email">
          <el-input
            id="email"
            :value="client.email"
            size="small"
            readonly
          />
        </el-form-item>
        <el-form-item v-if="$can('update', 'clients')" label="Пароль" prop="password">
          <el-button id="changePassword" @click="dialog = true" type="danger" size="small">Изменить</el-button>
        </el-form-item>
      </el-form>
    </main>
    <el-dialog id="dialogPassword" title="Изменить пароль" :visible.sync="dialog">
      <el-form
        id="formPassword"
        :model="formPassword"
        ref="formPassword"
        :rules="rulesPassword"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="Новый пароль" prop="password">
          <el-input id="password" v-model="formPassword.password" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button id="closeDialog" @click="dialog = false">Отменить</el-button>
        <el-button id="savePassword" type="primary" @click="savePassword">Изменить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { length, required, validatorAllLatine, validatorSpace } from "@/core/helpers/validators";
import { mapActions, mapState } from "vuex";
import OperatorService from "@/api/services/operator.service";

export default {
  name: "ClientEditTab",
  data() {
    return {
      dialog: false,
      canUseCrossSharing: 0,
      isFbs: undefined,
      loadedIsFbs: undefined,
      isSaving: false,
      form: {
        cross_sharing_enabled: 0,
        client_name: "",
        login: "",
        id_intercom: null,
        apartment: null,
      },
      rules: this.$can("update", "clients")
        ? {
            client_name: [required(), length(4, 100)],
            login: [required(), length(0, 100), validatorSpace, validatorAllLatine]
          }
        : null,
      formPassword: {
        password: "",
      },
      rulesPassword: {
        password: [required(), length(5, 100), validatorSpace, validatorAllLatine],
      },
    };
  },
  computed: {
    ...mapState("client", ["client"]),
    showManageFooter() {
      return this.$can("update", "clients") || this.$can("delete", "clients");
    },
  },
  watch: {
    client: {
      immediate: true,
      handler(client) {
        const { is_fbs, ...clientData } = client;
        this.form = Object.assign(this.form, clientData);
        this.isFbs = is_fbs;
        this.loadedIsFbs = is_fbs;
      },
    },
  },
  created() {
    OperatorService.getOperatorSettings()
      .then(data => {
        this.canUseCrossSharing = data.can_use_cross_sharing
      })
  },
  methods: {
    ...mapActions("client", {
      save: "UPDATE_CLIENT",
      saveFbs: "UPDATE_CLIENT_FBS",
      deleteUser: "DELETE_CLIENT",
    }),
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let data = {
            id: this.client.id_account,
            data: {
              client_name: this.form.client_name,
              login: this.form.login,
              password: this.form.password,
              phone: this.form.phone,
            },
          }
          if (this.canUseCrossSharing) {
            data.data.cross_sharing_enabled = this.form.cross_sharing_enabled
          }
          this.isSaving = true;
          const requests = [this.save(data)];
          if (
            this.$can("update", "clients_fbs") &&
            this.loadedIsFbs !== undefined &&
            this.isFbs !== this.loadedIsFbs
          ) {
            const isFbs = this.isFbs;
            requests.push(
              this.saveFbs({
                id: data.id,
                is_fbs: isFbs,
              }).then(() => {
                this.loadedIsFbs = isFbs;
              })
            );
          }
          Promise.all(requests)
            .then(() => {
              this.$message({
                message: "Информация обновлена",
                type: "success",
              });
            })
            .catch(() => {
              this.$message({
                message: `При редактировании клиента произошла ошибка`,
                type: "error",
              });
            })
            .finally(() => {
              this.isSaving = false;
            });
        }
        return valid;
      });
    },
    removeClient() {
      this.$confirm("Вы точно хотите удалить клиента?", "Удаление", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отмена",
        type: "warning",
      }).then(() => {
        this.deleteUser(this.client.id_account).then(() => {
          this.$message({
            message: "Клиент удален",
            type: "success",
          });
          window.history.back();
        });
      });
    },
    savePassword() {
      this.dialog = false;
      this.$set(this.form, "password", this.formPassword.password);
    }
  },
};
</script>
